var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56DE\u8DEF\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-156.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56DE\\u8DEF\\u6570",
    transform: "translate(156.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.982154,3.56136506 L4.57889793,3.56136506 C4.01607506,3.56136506 3.56136506,4.01607506 3.56136506,4.57889793 L3.56136506,27.982154 C3.56136506,28.5449769 4.01607506,28.9996869 4.57889793,28.9996869 L27.982154,28.9996869 C28.5449769,28.9996869 28.9996869,28.5449769 28.9996869,27.982154 L28.9996869,4.57889793 C28.9996869,4.01607506 28.5449769,3.56136506 27.982154,3.56136506 Z M23.0852771,18.6240314 C23.0852771,20.3824554 21.6639108,21.8070014 19.9150262,21.8070014 L13.3741977,21.8070014 L13.3741977,23.5050094 C13.3741977,23.6862574 13.1675113,23.7848309 13.0276006,23.6735383 L9.55844944,20.948458 C9.44715678,20.8626037 9.44715678,20.6940748 9.55844944,20.6082205 L13.0276006,17.8831403 C13.1675113,17.7718476 13.3741977,17.8736009 13.3741977,18.0516691 L13.3741977,19.7496771 L19.9150262,19.7496771 C20.5382651,19.7496771 21.0438518,19.2409107 21.0438518,18.6176718 L21.0438518,16.1088173 C21.0438518,15.9911651 21.1392455,15.8925916 21.2600775,15.8925916 L22.8722311,15.8925916 C22.9898834,15.8925916 23.0884569,15.9879853 23.0884569,16.1088173 L23.0884569,18.6240314 L23.0852771,18.6240314 Z M23.0026025,11.9496517 L19.5334514,14.6747319 C19.3935406,14.7860246 19.1868543,14.6842713 19.1868543,14.506203 L19.1868543,12.8081951 L12.6460258,12.8081951 C12.0227869,12.8081951 11.5172002,13.3169615 11.5172002,13.9402004 L11.5172002,16.4490549 C11.5172002,16.5667071 11.4218065,16.6652806 11.3009745,16.6652806 L9.68882084,16.6652806 C9.5711686,16.6652806 9.4725951,16.5698869 9.4725951,16.4490549 L9.4725951,13.9402004 C9.4725951,12.1817764 10.8939613,10.7572304 12.642846,10.7572304 L19.1836745,10.7572304 L19.1836745,9.05922237 C19.1836745,8.87797433 19.3903608,8.77940083 19.5302716,8.89069349 L22.9994227,11.6157737 C23.1138952,11.6952685 23.1138952,11.8637974 23.0026025,11.9496517 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/circuit.62ffa78fe692611c939a81a630b19744.svg";
export { ForwardRef as ReactComponent };